export const BACKEND_URL = "https://gsignature01.lm.r.appspot.com";
